export function buildVerificationUris(verificationUri: string) {
  const coloredUri = new URL(verificationUri);
  coloredUri.searchParams.set('color', 'developer');
  coloredUri.searchParams.set('studio', 'true');
  const signupUri = new URL('https://users.wix.com/login/signup/password');
  signupUri.searchParams.set('redirectTo', coloredUri.href);
  signupUri.searchParams.set('referralInfo', 'cli');
  coloredUri.searchParams.set('referralInfo', 'cli');

  return {
    coloredVerificationUri: coloredUri.toString(),
    signupUri: signupUri.toString(),
  };
}
